import { MatPaginatorIntl } from '@angular/material/paginator';

export function spanishPaginatorIntl(itemsLabel = 'Registros por página:'): MatPaginatorIntl {
  const labels = new MatPaginatorIntl();
  labels.itemsPerPageLabel = itemsLabel;
  labels.firstPageLabel = 'Primera página';
  labels.previousPageLabel = 'Página anterior';
  labels.nextPageLabel = 'Página siguiente';
  labels.lastPageLabel = 'Última página';
  labels.getRangeLabel = (page, size, total) => total === 0 || size === 0
    ? `0 de ${total}`
    : `${page * size + 1} – ${Math.min((page + 1) * size, total)} de ${total}`;
  return labels;
}
